export const configSstDh = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_gpvtile_url%/NCEP_ANLSIS_RTG_SST_LNDMSK/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "WX_SST",
      "url": "%expo_gpvtile_url%/NCEP_ANLSIS_RTG_SST_LNDMSK_%validtime%/%z%_%y%_%x%.png?palette=sst",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 1,
        "MaxZoom": 5,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 1,
          "South": -90,
          "East": 0,
          "North": 90
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};

export const configSstLayer = {
  "Name": "Sst",
  "Renderer": "Image",
  "Attributes": {
    "style": {
      "default": {
        "type": "grayscale_palette",
        "mag_filter": "NEAREST",
        "alternative_color": [0, 0, 0, 0],
        "palette": [
          [0, 0, 0, 0],        // x
          [184, 53, 142, 204],
          [184, 53, 142, 204],
          [184, 53, 142, 204],
          [184, 53, 142, 204],
          [184, 53, 142, 204],
          [184, 53, 142, 204],
          [184, 53, 142, 204],
          [184, 53, 142, 204],
          [184, 53, 142, 204],
          [184, 53, 142, 204],  // 10
          [184, 53, 142, 204],
          [184, 53, 142, 204],
          [184, 53, 142, 204],
          [184, 53, 142, 204],
          [184, 53, 142, 204],
          [184, 53, 142, 204],
          [184, 53, 142, 204],
          [184, 53, 142, 204],
          [184, 53, 142, 204],
          [184, 53, 142, 204],  // 20
          [184, 53, 142, 204],
          [184, 53, 142, 204],
          [184, 53, 142, 204],
          [184, 53, 142, 204],
          [184, 53, 142, 204],
          [184, 53, 142, 204],  // 26 -5°C
          [176, 54, 143, 204],
          [176, 54, 143, 204],
          [176, 54, 143, 204],
          [176, 54, 143, 204],  // 30
          [176, 54, 143, 204],  // 31 -4°C
          [168, 55, 143, 204],
          [168, 55, 143, 204],
          [168, 55, 143, 204],
          [168, 55, 143, 204],
          [168, 55, 143, 204],  // 36 -3°C
          [160, 56, 144, 204],
          [160, 56, 144, 204],
          [160, 56, 144, 204],
          [160, 56, 144, 204],  // 40
          [160, 56, 144, 204],  // 41 -2°C
          [152, 57, 144, 204],
          [152, 57, 144, 204],
          [152, 57, 144, 204],
          [152, 57, 144, 204],
          [152, 57, 144, 204],  // 46 -1°C
          [160, 32, 245, 204],
          [160, 32, 245, 204],
          [160, 32, 245, 204],
          [160, 32, 245, 204],  // 50
          [160, 32, 245, 204],  // 51 0°C
          [146, 30, 246, 204],
          [146, 30, 246, 204],
          [146, 30, 246, 204],
          [146, 30, 246, 204],
          [146, 30, 246, 204],  // 56 1°C
          [132, 28, 247, 204],
          [132, 28, 247, 204],
          [132, 28, 247, 204],
          [132, 28, 247, 204],  // 60
          [132, 28, 247, 204],  // 61 2°C
          [118, 26, 249, 204],
          [118, 26, 249, 204],
          [118, 26, 249, 204],
          [118, 26, 249, 204],
          [118, 26, 249, 204],  // 66 3°C
          [104, 24, 250, 204],
          [104, 24, 250, 204],
          [104, 24, 250, 204],
          [104, 24, 250, 204],  // 70
          [104, 24, 250, 204],  // 71 4°C
          [90, 22, 251, 204],
          [90, 22, 251, 204],
          [90, 22, 251, 204],
          [90, 22, 251, 204],
          [90, 22, 251, 204], // 76 5°C
          [76, 20, 252, 204],
          [76, 20, 252, 204],
          [76, 20, 252, 204],
          [76, 20, 252, 204], // 80
          [76, 20, 252, 204], // 81 6°C
          [62, 18, 253, 204],
          [62, 18, 253, 204],
          [62, 18, 253, 204],
          [62, 18, 253, 204],
          [62, 18, 253, 204], // 86 7°C
          [48, 16, 254, 204],
          [48, 16, 254, 204],
          [48, 16, 254, 204],
          [48, 16, 254, 204], // 90
          [48, 16, 254, 204], // 91 8°C
          [37, 13, 255, 204],
          [37, 13, 255, 204],
          [37, 13, 255, 204],
          [37, 13, 255, 204],
          [37, 13, 255, 204], // 96 9°C
          [1, 60, 187, 204],
          [1, 60, 187, 204],
          [1, 60, 187, 204],
          [1, 60, 187, 204],  // 100
          [1, 60, 187, 204],  // 101 10°C
          [5, 90, 195, 204],
          [5, 90, 195, 204],
          [5, 90, 195, 204],
          [5, 90, 195, 204],
          [5, 90, 195, 204],  // 106 11°C
          [9, 121, 203, 204],
          [9, 121, 203, 204],
          [9, 121, 203, 204],
          [9, 121, 203, 204], // 110
          [9, 121, 203, 204], // 111  12°C
          [14, 151, 212, 204],
          [14, 151, 212, 204],
          [14, 151, 212, 204],
          [14, 151, 212, 204],
          [14, 151, 212, 204],  // 116 13°C
          [18, 181, 220, 204],
          [18, 181, 220, 204],
          [18, 181, 220, 204],
          [18, 181, 220, 204],  // 120
          [18, 181, 220, 204],  // 121 14°C
          [22, 192, 228, 204],
          [22, 192, 228, 204],
          [22, 192, 228, 204],
          [22, 192, 228, 204],
          [22, 192, 228, 204],  // 126 15°C
          [26, 212, 236, 204],
          [26, 212, 236, 204],
          [26, 212, 236, 204],
          [26, 212, 236, 204],  // 130
          [26, 212, 236, 204],  // 131 16°C
          [30, 231, 244, 204],
          [30, 231, 244, 204],
          [30, 231, 244, 204],
          [30, 231, 244, 204],
          [30, 231, 244, 204],  // 136 17°C
          [34, 241, 247, 204],
          [34, 241, 247, 204],
          [34, 241, 247, 204],
          [34, 241, 247, 204],  // 140
          [34, 241, 247, 204],  // 141 18°C
          [37, 250, 250, 204],
          [37, 250, 250, 204],
          [37, 250, 250, 204],
          [37, 250, 250, 204],
          [37, 250, 250, 204],  // 146 19°C
          [45, 138, 80, 204],
          [45, 138, 80, 204],
          [45, 138, 80, 204],
          [45, 138, 80, 204], // 150
          [45, 138, 80, 204], // 151 20°C
          [62, 159, 72, 204],
          [62, 159, 72, 204],
          [62, 159, 72, 204],
          [62, 159, 72, 204],
          [62, 159, 72, 204], // 156 21°C
          [78, 180, 63, 204],
          [78, 180, 63, 204],
          [78, 180, 63, 204],
          [78, 180, 63, 204], // 160
          [78, 180, 63, 204], // 161 22°C
          [95, 202, 55, 204],
          [95, 202, 55, 204],
          [95, 202, 55, 204],
          [95, 202, 55, 204],
          [95, 202, 55, 204], // 166 23°C
          [111, 223, 46, 204],
          [111, 223, 46, 204],
          [111, 223, 46, 204],
          [111, 223, 46, 204],  // 170
          [111, 223, 46, 204],  // 171 24°C
          [253, 249, 13, 204],
          [253, 249, 13, 204],
          [253, 249, 13, 204],
          [253, 249, 13, 204],
          [253, 249, 13, 204],  // 176 25°C
          [253, 216, 16, 204],
          [253, 216, 16, 204],
          [253, 216, 16, 204],
          [253, 216, 16, 204],  // 180
          [253, 216, 16, 204],  // 181 26°C
          [252, 183, 19, 204],
          [252, 183, 19, 204],
          [252, 183, 19, 204],
          [252, 183, 19, 204],
          [252, 183, 19, 204],  // 186 27°C
          [252, 149, 23, 204],
          [252, 149, 23, 204],
          [252, 149, 23, 204],
          [252, 149, 23, 204],  // 190
          [252, 149, 23, 204],  // 191 28°C
          [252, 116, 26, 204],
          [252, 116, 26, 204],
          [252, 116, 26, 204],
          [252, 116, 26, 204],
          [252, 116, 26, 204],  // 196 29°C
          [255, 0, 0, 204],
          [255, 0, 0, 204],
          [255, 0, 0, 204],
          [255, 0, 0, 204], // 200
          [255, 0, 0, 204], // 201 30°C
          [255, 22, 47, 204],
          [255, 22, 47, 204],
          [255, 22, 47, 204],
          [255, 22, 47, 204],
          [255, 22, 47, 204], // 206 31°C
          [255, 44, 95, 204],
          [255, 44, 95, 204],
          [255, 44, 95, 204],
          [255, 44, 95, 204], // 210
          [255, 44, 95, 204], // 211 32°C
          [255, 66, 143, 204],
          [255, 66, 143, 204],
          [255, 66, 143, 204],
          [255, 66, 143, 204],
          [255, 66, 143, 204],  // 216 33°C
          [255, 88, 191, 204],
          [255, 88, 191, 204],
          [255, 88, 191, 204],
          [255, 88, 191, 204],  // 220
          [255, 88, 191, 204],  // 221 34°C
          [167, 25, 25, 204],
          [167, 25, 25, 204],
          [167, 25, 25, 204],
          [167, 25, 25, 204],
          [167, 25, 25, 204], // 226 35°C
          [146, 18, 18, 204],
          [146, 18, 18, 204],
          [146, 18, 18, 204],
          [146, 18, 18, 204], // 230
          [146, 18, 18, 204], // 231 36°C
          [125, 12, 12, 204],
          [125, 12, 12, 204],
          [125, 12, 12, 204],
          [125, 12, 12, 204],
          [125, 12, 12, 204], // 236 37°C
          [103, 6, 6, 204],
          [103, 6, 6, 204],
          [103, 6, 6, 204],
          [103, 6, 6, 204], // 240
          [103, 6, 6, 204], // 241 38°C
          [82, 0, 0, 204],
          [82, 0, 0, 204],
          [82, 0, 0, 204],
          [82, 0, 0, 204],
          [82, 0, 0, 204],  // 246 39°C
          [82, 0, 0, 204],
          [82, 0, 0, 204],
          [82, 0, 0, 204],
          [82, 0, 0, 204],  // 250
          [82, 0, 0, 204],  // 251 40°C
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0]
        ]
      }
    }
  }
};
